/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import Vue from 'vue'
import store from '@/store';
import axios from 'axios';
import {pathConstants} from '@/shared/pathConstants';

const showNotificationModal = function(data) {
  data.instance.$emit('bv::show::modal', data.id);
}

const closeNotificationModal = function(data) {
  data.instance.$emit('bv::hide::modal', data.id);
  store.commit('alert/clear');
}

const fetchNotificationCounters = function() {
    return axios
        .get(pathConstants.API + '/works/notification')
        .then(result => {
                return result.data;
            }, err => {
                Vue.$log.error('fetchNotificationCounters', err);
            }
        );
}

const fetchDashboardNotifications = function() {
  return axios
    .post(pathConstants.API + '/notifications/dashboard', ['LOT', 'CLIENT_REFERENCE', 'SIMULATION'])
    .then(result => {
        if (result.data.length) {
            return result.data;
        } else {
          return [];
        }
      }, err => {
        Vue.$log.error('fetchDashboardNotifications', err);
      }
    );
}

const fetchDashboardImportantNotifications = function(important) {
    return axios
        .post(pathConstants.API + '/notifications/dashboard?important=' + important,
        ['LOT', 'CLIENT_REFERENCE', 'SIMULATION'])
        .then(result => {
                if (result.data.length) {
                    return result.data;
                } else {
                    return [];
                }
            }, err => {
                Vue.$log.error('fetchDashboardNotifications', err);
            }
        );
}

const fetchOperationNotifications = function(operationId) {
  return axios
    .get(`${pathConstants.API}/notifications/operation/${operationId}`)
    .then(result => {
        if (result.data.length) {
            return result.data;
        } else {
          return [];
        }
      },
      err => {
        Vue.$log.error('fetchOperationNotifications', err);
      }
    );
}

const fetchWorkNotifications = function(workId) {
    return axios
        .get(`${pathConstants.API}/notifications/work/${workId}`)
        .then(result => {
                if (result.data.length) {
                    return result.data;
                } else {
                    return [];
                }
            },
            err => {
                Vue.$log.error('fetchWorkNotifications', err);
            }
        );
}

const markNotificationsAsRead = function(notificationsIds, refreshNoOfNotifs) {
    if (notificationsIds && notificationsIds.length) {
        return axios.post(pathConstants.API + '/notifications/mark-as-read', notificationsIds)
            .then(() => {
                if (refreshNoOfNotifs) {
                    store.dispatch('notification/getNotificationCountersAction');
                }
            }, err => {
                Vue.$log.error('fetchWorkNotifications', err);
            });
    }
}

const markNotificationsAsReadByEntityId = function(entitiesIds) {
    if (entitiesIds && entitiesIds.length) {
        return axios.post(pathConstants.API + '/notifications/mark-as-read-by-entityId', entitiesIds);
    }
}

const getConfiguration = function() {
    return axios.get(`${pathConstants.API}/notifications/configuration`)
        .then(result => {return result.data;},
            err => {Vue.$log.error('getConfiguration', err);});
}

const sendCallToActionNotificationToAigle = function(id) {
    return axios.get(`${pathConstants.API}/notifications/callToActionResponse/${id}`);
}

export const notificationService = {
    showNotificationModal,
    closeNotificationModal,
    fetchNotificationCounters,
    fetchDashboardNotifications,
    fetchDashboardImportantNotifications,
    fetchOperationNotifications,
    fetchWorkNotifications,
    markNotificationsAsRead,
    getConfiguration,
    markNotificationsAsReadByEntityId,
    sendCallToActionNotificationToAigle
};
